<template>
  <v-card class="pa-3" elevation="5">
    <title-card text="Descarga de Resultados"/>
    <v-list-item two-line v-for="resource in available_resources">
      <v-list-item-content>
        <a 
          :href="resource.url" 
          class="accent--text"
          target="_blank"
          style="text-decoration: none;"
        >
          <v-list-item-title class="font-weight-bold subtitle-1">
            {{resource.title}}
          </v-list-item-title>
          <v-list-item-subtitle class="">
            {{resource.subtitle}}
          </v-list-item-subtitle>
        </a>
      </v-list-item-content>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-list-item-icon  class="my-0 py-2">
            <v-btn 
              v-if="resource.need_generate"
              v-on="on"
              @click="generateFile(resource)"
              icon large
              color="primary"
            >
              <v-icon color="accent">cloud_download</v-icon>
            </v-btn>
            <v-btn 
              v-else
              v-on="on"
              :href="resource.url"
              target="_blank"
              icon large
              color="primary"
            >
              <v-icon color="accent">cloud_download</v-icon>
            </v-btn>
          </v-list-item-icon>
        </template>
        <span>Descargar {{resource.is_pdf ? 'PDF' : 'excel'}}</span>
      </v-tooltip>
    </v-list-item>
  </v-card>
</template>


<script>

import TitleCard from "../common/TitleCard";

export default {
  name: 'Resources',
  components:{
    TitleCard,
  },
  props:{
    ies:{
      type: Object,
      required: false,
    },
    period:{
      type: Object,
      required: false,
    },
  },
  data(){
    return {
      
      algo: [
        {'title': 'Resultados principales', 
          'subtitle': 'Resultados ejes y componentes',
          'url':'api/period/avg/export/'},
        {'title': 'Desglose de resultados', 
          'subtitle': 'Base de datos con todos los componentes',
          'url':'api/inquests/year/export/'},
        /*{'title': 'Informe (2017)', 
          'subtitle': 'Formato PDF',
          'url':'https:onigies.unam.mx'},*/
      ]
    }
  },
  computed: {
    available_resources(){
      var year = this.period ? this.period.year : null
      const api_url= process.env.VUE_APP_URL
      var resources
      if (this.ies){
        var curr_period = this.ies.period_ies.find(per_ies=> 
          per_ies.id == this.ies.current_period)
        resources = [{'title': `Resultados ${this.ies.siglas}`, 
            'subtitle': 'Tabla con resultados en formato excel',
            'url':`${api_url}/period/avg/export/${this.ies.id}/`,}]
        if (curr_period.annual_report)
          resources.push({'title': `Informe ${year}`, 'is_pdf': true,
            'subtitle': 'Informe en formato PDF',
            'url': curr_period.annual_report })
      }
      else if (year){
        resources = [{'title': `Resultados principales ${year}`,
            'subtitle': 'Resultados ejes y componentes',
            'url': `${api_url}/ies/results/${year}/export/`},
          {'title': `Desglose de resultados ${year}`,
            'subtitle': 'Base de datos con todas las respuestas',
            'need_generate': !this.period.export_file,
            'url': `${api_url}/inquests/${year}/export/`}]
        if (this.period.annual_report)
          resources.push({'title': `Informe ${year}`, 'is_pdf': true,
            'subtitle': 'Informe anual en formato PDF',
            'url':this.period.annual_report})
      }
      else{
        resources = [{'title': `Resultados principales`,
            'subtitle': 'Resultados ejes y componentes',
            'url': `${api_url}/ies/results/2017/export/`},
          {'title': `Desglose de resultados`,
            'subtitle': 'Base de datos con todas las respuestas',
            'url': `${api_url}/inquests/2017/export/`}]
      }
      return resources
    }
  },
  methods:{
    generateFile(resource){
      this.$store.dispatch('GENERATE_EXCEL', this.period.year)
        .then(res=>{
          window.open(resource.url, '_blank');
        })
    },
  },
  mounted(){
    //x.color_name = x.color.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
    //str = str.replace(/[\u0300-\u036f]/g, "")
    //str.split(search).join(replacement)
    this.api_url= process.env.VUE_APP_URL
  }
}
</script>

<style lang="scss" scoped>
</style>